module.exports = __webpack_public_path__ + "img/img-afd96a8d.9887a6df.png";